import "./island/style.css";
import { Island } from "./island/Island.js";
const island = new Island();
// Development QA handle; production interaction uses the visible controls.
if (import.meta.env.DEV) window.mimicoIsland = island;
if (import.meta.hot) import.meta.hot.dispose(() => island.dispose());
